import { createContext } from "react";

export const AccionesEmpleadosContext = createContext()
export const AccionesEmpleadosFormContext = createContext()
export const AccionesEmpleadosReportContext = createContext()